import { FC, ReactNode, useCallback, useEffect } from "react";
import Header from "./header/Header";
import Sidebar from "./Sidebar";

interface Props {
    title: string | ReactNode;
    subtitle?: string | ReactNode;
    children: ReactNode;
    mainActions?: ReactNode;
}
const MainLayout: FC<Props> = ({ title, subtitle, children, mainActions }) => {
    const globalSearchCallback = useCallback((event: KeyboardEvent) => {
        if (event.ctrlKey && event.key === "k") {
            console.log("Ctrl + K pressed");
            document.getElementById("master-search")?.focus();
        }
    }, []);

    useEffect(() => {
        document && document.addEventListener("keydown", globalSearchCallback);
        return () => {
            document &&
                document.removeEventListener("keydown", globalSearchCallback);
        };
    });

    return (
        <div className="flex h-full gap-10">
            <Sidebar />
            <div className="l flex w-full flex-col gap-8 overflow-x-auto pr-10">
                <Header />
                <div className="flex items-center justify-between">
                    <div className="flex flex-col gap-1">
                        <h2 className="text-3xl">{title}</h2>
                        <div>{subtitle}</div>
                    </div>
                    <div className="flex h-12 gap-2">{mainActions}</div>
                </div>
                <div>{children}</div>
            </div>
        </div>
    );
};

export default MainLayout;
